module.exports = __webpack_public_path__ + "img/carret-down.ef65a139.svg";